<template>
  <v-navigation-drawer
    id="account-drawer"
    v-model="drawer"
    fixed
    right
    width="86%"
  >
    <v-btn
      fab
      absolute
      icon
      @click="drawer = false"
    >
      <v-icon color="white">
        $faTimes
      </v-icon>
    </v-btn>
    <v-list class="pt-0 mt-7">
      <v-list-item>
        <v-list-item-content class="pt-0">
          <account-icon :size="80" />
          <v-list-item-title
            class="user-name"
            v-text="userName"
          />

          <v-list-item-subtitle
            class="user-role"
            v-text="userRoleOnOrg"
          />
        </v-list-item-content>
      </v-list-item>
      <v-divider style="background-color:#456E6C" />
      <v-list-item
        class="account-menu-item"
        @click="goToAccountSettings"
      >
        <v-list-item-icon class="account-menu-item__icon">
          <v-icon
            size="15"
            color="white"
          >
            $faUser
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content class="account-menu-item__content">
          Account Settings
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        class="account-menu-item"
        @click="logout"
      >
        <v-list-item-icon class="account-menu-item__icon">
          <v-icon
            size="15"
            color="white"
          >
            $faArrowRight
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content class="account-menu-item__content">
          Log out
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  import accountMenuMixin from '@/helpers/account-menu-mixin.js'
  export default {
    name: 'AccountDrawer',
    mixins: [accountMenuMixin],
    computed: {
      drawer: {
        get () {
          return this.$store.state.accountDrawer
        },
        set (val) {
          this.$store.commit('setAccountDrawer', val)
        },
      },
    },
  }
</script>

<style lang="scss">
  #account-drawer {
    background-color: #34455f;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
    .user-name {
      font-family: 'Degular', sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 20px;
      line-height: 25px;
      text-align: center;
      letter-spacing: 0.214877px;
      color: #FFFFFF;
      text-transform: unset;
      margin-top: 15px;
    }
    .user-role {
      font-family: "Degular", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 18px;
      text-align: center;
      letter-spacing: 0.382511px;
      color: #FFFFFF;
      margin-top: 2px;
      margin-bottom: 7px;
    }
    .account-menu-item {
      height: 54px;
    }
    .account-menu-item__content {
        font-family: 'Degular', sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        letter-spacing: 1px;
        text-transform: uppercase;
        color: #FFFFFF !important;
    }
    .account-menu-item__icon {
      margin-right: 10px;
    }
  }
</style>
